import React from 'react'
import PropTypes from 'prop-types'

import { deepSetObject, digObject } from '@domain-group/javascript-utils'

import { DashboardModule, Form } from '@domain-group/suit-theme'

import ArtworkRequiredPages from '../ArtworkRequiredPages'

const handleChangeMergePageOffset = (value, options, setEntityState) => {
  const numberString = !Number.isNaN(+value) ? value : ''
  const updatedOptions = deepSetObject(options, 'artwork.merge_page_offset', numberString)

  setEntityState({ options: updatedOptions })
}

const ArtworkSettings = (props) => {
  const { serviceProductForm } = props
  const {
    entityState,
    entityState: { options },
    handlers,
    setEntityState,
  } = serviceProductForm

  const artwork = digObject(entityState, 'options.artwork', {})
  const {
    imposable,
    max_pages,
    merge_page_offset,
    merge_pages,
    min_pages,
    pages_sortable,
    permit_duplicate_page_types,
  } = artwork

  const { template } = digObject(entityState, 'options', {})

  return (
    <DashboardModule title="Artwork Settings">
      <Form padding="large">
        <Form.Row>
          <Form.Field label="Min. Pages">
            <input
              data-value-type="integer"
              name="options.artwork.min_pages"
              type="text"
              value={min_pages}
              {...handlers}
            />
          </Form.Field>

          <Form.Field label="Max. Pages" marginTop={['large', 0]}>
            <input
              data-value-type="integer"
              name="options.artwork.max_pages"
              type="text"
              value={max_pages}
              {...handlers}
            />
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field label="Pages Sortable">
            <select
              data-value-type="boolean"
              name="options.artwork.pages_sortable"
              value={pages_sortable}
              {...handlers}
            >
              <option value="false">No</option>
              <option value="true">Yes</option>
            </select>
          </Form.Field>

          <Form.Field label="Imposable" marginTop={['large', 0]}>
            <select data-value-type="boolean" name="options.artwork.imposable" value={imposable} {...handlers}>
              <option value="false">No</option>
              <option value="true">Yes</option>
            </select>
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field label="Permit Duplicate Pages">
            <select
              data-value-type="boolean"
              name="options.artwork.permit_duplicate_page_types"
              value={permit_duplicate_page_types}
              {...handlers}
            >
              <option value="false">No</option>
              <option value="true">Yes</option>
            </select>
          </Form.Field>

          <Form.Field label="Merge Pages" marginTop={['large', 0]}>
            <select data-value-type="boolean" name="options.artwork.merge_pages" value={merge_pages} {...handlers}>
              <option value="false">No</option>
              <option value="true">Yes</option>
            </select>
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field label="Merge Page Offset (px)">
            <input
              onChange={e => handleChangeMergePageOffset(e.target.value, options, setEntityState)}
              name="options.artwork.merge_page_offset"
              type="text"
              value={merge_page_offset}
            />
          </Form.Field>

          {template && template.pages && !!template.pages.length && (
            <Form.Field label="Bleed (mm)" marginTop={['large', 0]}>
              <input
                name="options.template.bleed"
                type="number"
                value={template.bleed || ''}
                {...handlers}
              />
            </Form.Field>
          )}
        </Form.Row>

        {template && template.pages && !!template.pages.length && (
          <ArtworkRequiredPages serviceProductForm={serviceProductForm} />
        )}
      </Form>
    </DashboardModule>
  )
}

ArtworkSettings.propTypes = {
  serviceProductForm: PropTypes.object.isRequired,
}

export default ArtworkSettings
